module.exports = __webpack_public_path__ + "media/images/default/homepage/environment/group_33676_orange_140-96dafee04a6ce75fe535b39175a8ec89.svg";